import { Component, OnInit, Input, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { environment } from 'src/environments/environment';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() login: string;
  @ViewChild('popupContent') popupContent!: TemplateRef<any>;
  communityData: any;
  baseUrl = environment.imgUrl;
  currentUser: any;
  closeResult: string = '';
  showPopup: boolean = true;
  private pollInterval: any;

  constructor(
    private authService: AuthservicesService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('ministry_currentUser'));
    if (this.currentUser?.id) {
      this.communityDetail();
    } else {
      console.error('No current user ID found in localStorage');
    }
  }

  /**
   * Check if the user's profile is active
   * Returns true if isActive is truthy (not false, null, undefined, or empty string)
   */
  isProfileActive(): boolean {
    // Check communityData first (from API response)
    if (this.communityData?.isActive) {
      return true;
    }
    // Check currentUser as fallback (from localStorage)
    if (this.currentUser?.isActive) {
      return true;
    }
    return false;
  }

  /**
   * Check profile status and open/close popup accordingly
   * Only open popup if user.isEmailVarified == true AND user.isFirstUpdateDone == true AND profile is not active
   */
  checkProfileStatus(): void {
    let user = JSON.parse(localStorage.getItem('ministry_currentUser'));
    
    // Only check profile status if user has verified email AND completed first update
    if (user?.isEmailVarified === true) {
      if (this.isProfileActive()) {
        // Profile is now active, close the popup
        this.closePopup();
        // Stop polling since profile is now active
        this.stopPolling();
      } else {
        // Profile is still inactive, open the popup if not already open
        this.openPopup();
      }
    } else {
      // Conditions not met (email not verified or first update not done), stop polling
      this.stopPolling();
    }
  }

  /**
   * Start polling to check profile status
   */
  startPolling(): void {
    // Check immediately
    this.checkProfileStatus();
    // Then poll every 5 seconds
    this.pollInterval = setInterval(() => {
      this.checkProfileStatus();
    }, 5000);
  }

  /**
   * Stop polling
   */
  stopPolling(): void {
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
      this.pollInterval = null;
    }
  }

  /**
   * Clean up on component destroy
   */
  ngOnDestroy(): void {
    this.stopPolling();
  }

  /**
   * Activate the user profile by calling the API
   */
  activateProfile(): void {
    this.authService.activateUser().subscribe(
      (res: any) => {
        console.log('Profile activated successfully:', res);
        // Show success message from API response
        if (res?.message) {
          this.authService.successMessage(res.message, 'success');
        } else {
          this.authService.successMessage('User activated successfully!', 'success');
        }
        // Update local storage with the new active status
        if (this.currentUser) {
          this.currentUser.isActive = true;
          localStorage.setItem('ministry_currentUser', JSON.stringify(this.currentUser));
        }
        if (this.communityData) {
          this.communityData.isActive = true;
          localStorage.setItem('ministry_currentUser', JSON.stringify(this.communityData));
        }
        // Check profile status which will close the popup
        this.checkProfileStatus();
      },
      (error) => {
        console.error('Error activating profile:', error);
        const errorMessage = error?.error?.message || 'Failed to activate profile. Please try again.';
        this.authService.successMessage(errorMessage, 'error');
      }
    );
  }

  openPopup(): void {
    this.modalService.open(this.popupContent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      windowClass: 'header-popup-modal'
    }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  closePopup(): void {
    this.modalService.dismissAll();
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getError(event: any) {
    event.target.src = environment.profileImage || 'assets/images/church.jpeg';
  }

  communityDetail() {
    this.authService.communitydetails(this.currentUser.id).subscribe(
      (res: any) => {
        this.communityData = res?.data;
        localStorage.setItem('ministry_currentUser', JSON.stringify(this.communityData));
        // Check profile status and start polling if inactive
        this.startPolling();
      },
      error => {
        console.error('Error fetching community details:', error);
        // Still try to check status with existing data
        this.startPolling();
      }
    );
  }

  setUrl(photo: string | null): string {
  if (!photo){
    return 'assets/images/church.jpeg';
    }
    const parts = photo.split('uploads');
    if (parts.length < 2) {
    return 'assets/images/church.jpeg'; // invalid format
  }
   const finalUrl = `http://localhost:9000/uploads${parts[1]}`;
    return finalUrl;
  }

  onImgError(event: any) {
  if (!event.target.dataset.fallbackApplied) {
    event.target.dataset.fallbackApplied = "true";
    event.target.src = 'assets/images/church.jpeg';
  }
}
}
